module.exports = __webpack_public_path__ + "static/media/Jengibre y Frambuesa Espumoso.95727fcb.webp";